__turbopack_context__.v({
  "accent": "g1ZCuq_accent",
  "agree": "g1ZCuq_agree",
  "button": "g1ZCuq_button",
  "container": "g1ZCuq_container",
  "content": "g1ZCuq_content",
  "description": "g1ZCuq_description",
  "dots": "g1ZCuq_dots",
  "form": "g1ZCuq_form",
  "input": "g1ZCuq_input",
  "overflow": "g1ZCuq_overflow",
  "row": "g1ZCuq_row",
  "title": "g1ZCuq_title",
});
